module.exports = __webpack_public_path__ + "533e3e4a66977e838ba13ec0bfe90052.svg";